import React from 'react';
import './MessageArchive.css';

const MessageArchive = () => {
  return (
    <div className="message-archive">
      <h2>Message Archive</h2>
      <div className="archive-content">
        <p>Message archive component coming soon...</p>
      </div>
    </div>
  );
};

export default MessageArchive; 